import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import ImageWatermark from '../../components/ImageWatermark';

const ImageWatermarkPage: React.FC = () => (
  <ToolLayout
    title="Add Watermark to Image Online Free | AllTools"
    description="Add text watermarks to images. Customize font, color, opacity, and position. Free watermark tool."
    canonicalPath="/image-watermark"
  >
    <ImageWatermark />
  </ToolLayout>
);

export default ImageWatermarkPage;
